module.exports = __webpack_public_path__ + "static/media/mat.5111c0fa.png";